import { type i18n as I18n, type TFunction } from 'i18next';

import { Field } from '../dynamic-input-fields.type';

import { getOptionalLabel } from './get-optional-label';

const getLabel = (field: Field, t: TFunction, i18n: I18n) => {
  return i18n.exists(`${field.slug}FormFieldLabel`) ? t(`${field.slug}FormFieldLabel`) : field.name;
};

export const generateLabel = (field: Field, t: TFunction, i18n: I18n, optionalFields?: boolean) => {
  return `
    ${getLabel(field, t, i18n)}
    ${getOptionalLabel(t, field.isRequired, optionalFields)}`;
};
